import { FC } from 'react'

import { RestrictedWordMatch } from '@api'

import { ExclamationIcon } from '@/assets/icons/icon-exclamation'
import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import { DialogProps } from '../types'

interface Props extends DialogProps {
  match: RestrictedWordMatch
}

export const BlacklistedWordUsageDetection: FC<Props> = ({
  isOpen,
  onClose,
  match,
}) => {
  return (
    <Dialog
      show={isOpen}
      bigDialog
      panelClassName="text-center lg:max-w-[680px]"
      onClose={onClose}
    >
      <div>
        <Dialog.Header className="mb-[6px] space-y-4">
          <ExclamationIcon className="mx-auto" />
          <Dialog.Title className="text-2xl leading-8">
            Blacklisted Word Detected!
          </Dialog.Title>
        </Dialog.Header>
        <div className="space-y-2 text-center">
          <Dialog.Description className="text-base leading-6">
            We detected the use of the {match?.restrictionType.toLowerCase()}{' '}
            <span className="text-title">
              &quot;{match?.restrictedWord}&quot;
            </span>{' '}
            which does not comply with the rules of OnlyFans. Edit your message
            before sending!
          </Dialog.Description>
          <Dialog.Description className="block text-base leading-6">
            This has been reported to the team admin.
          </Dialog.Description>
        </div>
        <Dialog.Footer>
          <Button
            variant="outline"
            className="w-full"
            onClick={onClose}
          >
            Edit Text
          </Button>
        </Dialog.Footer>
      </div>
    </Dialog>
  )
}
